import * as React from 'react';
import type { SVGProps } from 'react';
const SvgApplicationLayerProtocol = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    {...props}
  >
    <path
      fill="#4A5468"
      d="M19.664 15.226a.9.9 0 0 1 .805 1.61l-8.066 4.032a.9.9 0 0 1-.805 0l-8.066-4.032a.9.9 0 0 1 .804-1.61L12 19.058z"
    />
    <path
      fill="#4A5468"
      d="M19.664 11.192a.9.9 0 0 1 .805 1.61l-8.066 4.033a.9.9 0 0 1-.805 0l-8.066-4.033a.9.9 0 0 1 .804-1.61L12 15.024z"
    />
    <path
      fill="#4A5468"
      fillRule="evenodd"
      d="M11.694 3.085a.9.9 0 0 1 .71.041l8.065 4.034a.9.9 0 0 1 0 1.609l-8.066 4.033a.9.9 0 0 1-.805 0L3.532 8.77a.9.9 0 0 1 0-1.61l8.066-4.033zM5.945 7.964 12 10.99l6.054-3.027L12 4.937z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgApplicationLayerProtocol;
